import { render, staticRenderFns } from "./RefundProductTitleDetails.vue?vue&type=template&id=08874fc0&"
import script from "./RefundProductTitleDetails.vue?vue&type=script&lang=js&"
export * from "./RefundProductTitleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports